import { BaseParser, DATA_TYPE_DATA, TYPE_PSSESSION } from './baseExtractor.js';
import { ExtraConfigKey, NameExtraConfig } from '../commonPlotDefinitions.js'
import { getScanFilesList } from '@/common/sharedDefinitions/reportDefinitions'
import store from '@/store'

const iconPssession = 'PSDataFile.png';

// Regex for extraction
const reTechnique = /technique=(\d+)/i;
const RE_VERIFY_TYPE_TIME = /(time?[s]?)|(^s(econds)?)/i;
const RE_VERIFY_TYPE_POTENTIAL = /(pot(ential)?[s]?)|(^v(olts)?)/i;
const RE_VERIFY_TYPE_CURRENT = /(curr(ent)?[s]?)|(^a(mp)?(ere)?(s)?)/i;

class PSSessionExtractor extends BaseParser {
  extractDatavaluePssession(index, datasetValues, regexTest, typeStr, titlePlot, returnValue){
    if (
      index < datasetValues.length &&
      (regexTest.test(this.getValCaseIn(datasetValues[index], 'description')) ||
        regexTest.test(this.getValCaseIn(datasetValues[index], 'type')))
    ) {
      return this.getArrayFromDatavalue(this.getValCaseIn(datasetValues[index], 'datavalues'));
    }else{
      returnValue.warnings.push(`${typeStr} value wasn't found in dataset ${titlePlot}. You won't be able to perform all the analysis available in djuli`);
      return []
    }
  }

  getValCaseIn(objectInput, keyInput){
    if(typeof(objectInput[keyInput]) !== 'undefined'){
      return objectInput[keyInput]
    }
    const keyFound = Object.keys(objectInput).find(key => keyInput.localeCompare(key, undefined, { sensitivity: 'base' }) === 0)
    if(typeof(keyFound) !== 'undefined'){
      return objectInput[keyFound]
    }
    return undefined
  }

  getArrayFromDatavalue(datavalue) {
    const newArray = Array(datavalue.length).fill(0);
    for (let j = 0; j < datavalue.length; j++) {
      newArray[j] = this.getValCaseIn(datavalue[j], 'v');
    }
    return newArray;
  }

  //Get the index of the element that matches with the description and datavaluetype. It was built for the pssession files.
getIndexByType(array, description, datavaluetype) {
  return array.findIndex((element) => {
    const elementDescription = this.getValCaseIn(element, 'description');
    const elementDataValueType = this.getValCaseIn(element, 'datavaluetype');

    return (
      elementDescription === description &&
      elementDataValueType === datavaluetype
    );
  });
}

  validateArray(arr, identifierStr, warnings){
    const validatedArr = arr.filter(t => typeof(t) !== 'undefined' && t !== null)
    if(validatedArr.length === arr.length)
      return true;
    if(validatedArr.length === 0){
      warnings.push(`The field ${identifierStr} doesn't contain any valid element`)
      return false
    }
    warnings.push(`The field ${identifierStr} contains ${arr.length - validatedArr.length} invalid elements`)
    return false
  }

  async _doParse(parent, fileName, data, report) {
    const returnValue = this.getNewReturnValue();
    const dataFiltered = data.replaceAll('\0', '').replaceAll('\uFFFD', '').replaceAll('\uFEFF', ''); // Remove null characteres
    const jsonData = JSON.parse(dataFiltered); // Convert to JSON
    const measurements = this.getValCaseIn(jsonData, 'measurements')
    //=====================
    for (let j = 0; j < measurements.length; j++) {
      const measuTitle = this.getValCaseIn(measurements[j], 'title');
      const dataSet = this.getValCaseIn(measurements[j], 'dataset');
      const curves = this.getValCaseIn(measurements[j], 'curves');
      const eisDataList = this.getValCaseIn(measurements[j], 'eisdatalist');
      const technique = parseInt(reTechnique.exec(this.getValCaseIn(measurements[j], 'method'))[1]); // Get the technique
      const datasetValues = this.getValCaseIn(dataSet, 'values');
      let typeDataSet = this.getValCaseIn(dataSet, 'type');

      //Validate the array, it could be empty and the value in the other segment
      if (
        typeDataSet === 'PalmSens.Data.DataSetCommon' &&
        curves.length === 0 &&
        eisDataList.length !== 0
      ) {
        try {
          await parent.$confirm(
            `The file "${fileName}" measurement ${j} has the information in the EIS, should I use it?`,
            'Special Pssession',
            'question',
            {
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
            },
          );
          typeDataSet = 'PalmSens.Data.DataSetEIS';
        } catch (e) {
          returnValue.warnings.push(`The file "${fileName}" measurement ${j} had an empty data structure. Please verify.`);
          continue;
        }
      }
      if (
        typeDataSet === 'PalmSens.Data.DataSetEIS' &&
        eisDataList.length === 0 &&
        curves.length !== 0
      ) {
        try {
          await parent.$confirm(
            `The file "${fileName}" measurement ${j} has data in the common structure and not EIS, should I use it?`,
            'Special Pssession',
            'question',
            {
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
            },
          );
          typeDataSet = 'PalmSens.Data.DataSetCommon';
        } catch {
          returnValue.warnings.push(`The file "${fileName}" measurement ${j} had an empty EIS data structure. Please verify.`);
          continue;
        }
      }

      if (typeDataSet === 'PalmSens.Data.DataSetCommon') {
        let lastIndex = 0;
        const timeIndex = 0;
        //Clean first the hidden curves
        const valuesFiltered = datasetValues.filter(
          (v) => typeof v.hidden === 'undefined' || !v.hidden,
        );
        //Clean multiple potentials together
        for (let k = 0; k < (valuesFiltered.length -1); k++) {
          if (
            (RE_VERIFY_TYPE_POTENTIAL.test(valuesFiltered[k].description) ||
              RE_VERIFY_TYPE_POTENTIAL.test(valuesFiltered[k].type)) &&
            (RE_VERIFY_TYPE_POTENTIAL.test(valuesFiltered[k + 1].description) ||
              RE_VERIFY_TYPE_POTENTIAL.test(valuesFiltered[k + 1].type))
          ) {
            valuesFiltered.splice(k, 1);
            k--;
          }
        }
        for (let k = 0; k < curves.length; k++) {
          const poteIndex = 1 + k * 3;
          const currIndex = 2 + k * 3;
          const revCurrIndx = 3 + k * 3;
          lastIndex = revCurrIndx;
          const curveTitle = this.getValCaseIn(curves[k], 'title')
          if (poteIndex >=valuesFiltered.length && currIndex >= valuesFiltered.length) {
            returnValue.warnings.push(`Error extracting curve ${curveTitle}. The file's structure isn't recognized. Please contact the system's administrator.`,);
            continue;
          }

          let titlePlot = measuTitle;
          if (curveTitle !== 'Curve') {
            titlePlot += ' - ' + curveTitle;
          }
          const dataExtract = this.getDataFromFileName(
            titlePlot,
            null,
            fileName,
          ); //Extract data from the file name
          const newProcessedDatObjt = {
            title: titlePlot,
            technique: technique,
            time: this.extractDatavaluePssession(timeIndex, valuesFiltered, RE_VERIFY_TYPE_TIME, 'Time', titlePlot, returnValue),
            potential: this.extractDatavaluePssession(poteIndex, valuesFiltered, RE_VERIFY_TYPE_POTENTIAL, 'Potential', titlePlot, returnValue),
            current: this.extractDatavaluePssession(currIndex, valuesFiltered, RE_VERIFY_TYPE_CURRENT, 'Current', titlePlot, returnValue),
            fileName: fileName,
            group: dataExtract.group,
            concUnit: dataExtract.concUnit,
          };

          if (typeof dataExtract.mapping !== 'undefined') {
            newProcessedDatObjt.mapping = dataExtract.mapping;
            report[ExtraConfigKey][NameExtraConfig.MappingPresent] = true;
            store.commit('SET_MAPPING_FLAG_ReportViewer', true);
          }
          if (typeof dataExtract.scan !== 'undefined') {
            newProcessedDatObjt.scan = dataExtract.scan;
            if (typeof report[ExtraConfigKey][NameExtraConfig.ScansFiles] === 'undefined') {
              report[ExtraConfigKey][NameExtraConfig.ScansFiles] = {};
            }
            if (typeof report[ExtraConfigKey][NameExtraConfig.ScansFiles][newProcessedDatObjt.scan] === 'undefined') {
              // Create a dictionary of using the scan as the key
              //  it is a dictionary because it is an easy way to create a hashtable
              report[ExtraConfigKey][NameExtraConfig.ScansFiles][newProcessedDatObjt.scan] = true;
              const scanFilesList = await getScanFilesList(report);
              store.commit('SET_SCAN_FILES_ReportViewer', scanFilesList);
            }
          }
          if (
            (k + 1 < curves.length &&
            this.getValCaseIn(curves[k + 1], 'title').includes('Reverse') &&
            revCurrIndx <valuesFiltered.length &&
            this.getValCaseIn(valuesFiltered[revCurrIndx], 'type').includes('DataArrayCurrents'))
          ) {
            //If there is a reverse current ther would be reverse in the title and current type in the fourth element
            report[ExtraConfigKey][NameExtraConfig.ReverseCurrentPresent] = true;
            newProcessedDatObjt.reverseCurrent = this.getArrayFromDatavalue(this.getValCaseIn(valuesFiltered[revCurrIndx], 'datavalues')); //Save the Reverse Current from the file
            k++;
            // Validates for Forward current after the reverse current
            if (
              (k + 1 < curves.length &&
              this.getValCaseIn(curves[k + 1], 'title').includes( 'Forward') &&
              revCurrIndx + 1 < valuesFiltered.length &&
              this.getValCaseIn(valuesFiltered[revCurrIndx + 1], 'type').includes('DataArrayCurrents'))
            ) {
              newProcessedDatObjt.current = this.getArrayFromDatavalue(this.getValCaseIn(valuesFiltered[revCurrIndx + 1], 'datavalues')); //Save the Reverse Current from the file
              k++;
            }
            lastIndex = revCurrIndx + 1;
          }
          else if (// This is horrible logic added by Sindre. TODO: Make it better
            (k + 2 < curves.length &&
            this.getValCaseIn(curves[k + 2], 'title').includes('Reverse') &&
            (revCurrIndx+1) < valuesFiltered.length &&
            this.getValCaseIn(valuesFiltered[(revCurrIndx+1)], 'type').includes('DataArrayCurrents'))
          ){
              //If there is a reverse current ther would be reverse in the title and current type in the fourth element
            report[ExtraConfigKey][NameExtraConfig.ReverseCurrentPresent] = true;
            newProcessedDatObjt.reverseCurrent = this.getArrayFromDatavalue(this.getValCaseIn(valuesFiltered[revCurrIndx+1], 'datavalues')); //Save the Reverse Current from the file
            k = k+2;
            // Validates for Forward current after the reverse current
            if (
              (k + 1 < curves.length &&
              this.getValCaseIn(curves[k + 1], 'title').includes('Forward') &&
              revCurrIndx + 2 < valuesFiltered.length &&
              this.getValCaseIn(valuesFiltered[revCurrIndx + 2], 'type').includes('DataArrayCurrents'))
            ) {
              newProcessedDatObjt.current = this.getArrayFromDatavalue(this.getValCaseIn(valuesFiltered[revCurrIndx + 2], 'datavalues')); //Save the Reverse Current from the file
              k++;
            }
            lastIndex = revCurrIndx + 2;
          }
          const anyValid = (this.validateArray(newProcessedDatObjt.time, `'time' in ${titlePlot}`, returnValue.warnings)
                            || this.validateArray(newProcessedDatObjt.potential, `'potential' in ${titlePlot}`, returnValue.warnings)
                            || this.validateArray(newProcessedDatObjt.current, `'current' in ${titlePlot}`, returnValue.warnings))
          if(anyValid)
            returnValue.processedData.push(newProcessedDatObjt);
          else
            returnValue.warnings.push(
              `${titlePlot} empty. Dataline wasn't included`,
            );
        }

        const remainingDataCount = valuesFiltered.length - (lastIndex + 1);
        if (remainingDataCount > 0) {
          returnValue.warnings.push(`Djuli didn't extract ${remainingDataCount} datatable from the Raw Data. Please validate that the Data Table and the curves match.`);
        }
      } else if (typeDataSet === 'PalmSens.Data.DataSetEIS') {
        //Type Data set EIS, it has the informaiton in another part of the file
        for (let k = 0; k < eisDataList.length; k++) {
          const eisDataSet = this.getValCaseIn(eisDataList[k], 'dataset')
          const eisDataSetValues = this.getValCaseIn(eisDataSet, 'values')
          const ZReIndex = this.getIndexByType( eisDataSetValues, 'ZRe',        'PalmSens.Data.GenericValue');
          const ZImIndex = this.getIndexByType( eisDataSetValues, 'ZIm',        'PalmSens.Data.GenericValue');
          const freqIndex = this.getIndexByType(eisDataSetValues, 'Frequency',  'PalmSens.Data.GenericValue');

          let titlePlot = measuTitle;
          const eisDataTitle = this.getValCaseIn(eisDataList[k], 'title')
          if (eisDataTitle !== '') {
            titlePlot += ' - ' + eisDataTitle;
          }

          const ZReList = this.getArrayFromDatavalue(this.getValCaseIn(datasetValues[ZReIndex], 'datavalues'));
          const ZImList = this.getArrayFromDatavalue(this.getValCaseIn(datasetValues[ZImIndex], 'datavalues'));
          if (ZReList.length !== ZImList.length) {
            returnValue.warnings.push(`The Raw  Data ${titlePlot} '${k}' has a non-symetric impedance array, and djuli skipped it. Please verify the data.`);
            continue;
          }

          const dataExtract = this.getDataFromFileName(titlePlot); //Extract data from the file name
          const newProcessedDatObjt = {
            title: titlePlot,
            technique: technique,
            impedance_re: ZReList,
            impedance_im: ZImList,
            frequency: this.getArrayFromDatavalue(this.getValCaseIn(datasetValues[freqIndex], 'datavalues')),
            fileName: fileName,
            group: dataExtract.group,
            concUnit: dataExtract.concUnit,
          };
          if (typeof dataExtract.mapping !== 'undefined') {
            newProcessedDatObjt.mapping = dataExtract.mapping;
          }
          if (typeof dataExtract.scan !== 'undefined') {
            newProcessedDatObjt.scan = dataExtract.scan;
          }
          const anyValid = (this.validateArray(newProcessedDatObjt.impedance_re, `'impedance_re' in ${titlePlot}`, returnValue.warnings)
                            || this.validateArray(newProcessedDatObjt.impedance_im, `'impedance_im' in ${titlePlot}`, returnValue.warnings)
                            || this.validateArray(newProcessedDatObjt.frequency, `'frequency' in ${titlePlot}`, returnValue.warnings))
          if(anyValid)
            returnValue.processedData.push(newProcessedDatObjt);
          else
            returnValue.warnings.push(
              `${titlePlot} empty. Dataline wasn't included`,
            );
        }
      } else {
        returnValue.warnings.push(
          `Dataset ${j} error. It is not possible to extract the dataset type "${typeDataSet}". Please contact the administrator of the system.`,
        );
        continue;
      }
    }
    returnValue.lastError = returnValue.processedData.length === 0
                              ? `File '${fileName}' is empty`
                              : '';
    returnValue.dataType = DATA_TYPE_DATA;
    returnValue.type = TYPE_PSSESSION;
    returnValue.icon = iconPssession;
    returnValue.success = returnValue.processedData.length > 0;

    return returnValue;
  }
}

export{
  PSSessionExtractor,
  RE_VERIFY_TYPE_TIME,
  RE_VERIFY_TYPE_POTENTIAL,
  RE_VERIFY_TYPE_CURRENT,
};
